/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlternativeSize
 */
export interface AlternativeSize {
    /**
     * 
     * @type {string}
     * @memberof AlternativeSize
     */
    size?: AlternativeSizeSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof AlternativeSize
     */
    ean?: string;
}


/**
 * @export
 */
export const AlternativeSizeSizeEnum = {
    Dimension3060: 'DIMENSION_30_60',
    Dimension6060: 'DIMENSION_60_60',
    Dimension60120: 'DIMENSION_60_120',
    Dimension3030: 'DIMENSION_30_30',
    Dimension120120: 'DIMENSION_120_120',
    Dimension8080: 'DIMENSION_80_80',
    Dimension80160: 'DIMENSION_80_160',
    Dimension100200: 'DIMENSION_100_200',
    Dimension7530: 'DIMENSION_7_5_30',
    Dimension5050: 'DIMENSION_50_50',
    Dimension1590: 'DIMENSION_15_90',
    Dimension4545: 'DIMENSION_45_45',
    Dimension4040: 'DIMENSION_40_40',
    Dimension408283: 'DIMENSION_40_8_28_3',
    Dimension39898: 'DIMENSION_39_8_9_8',
    Dimension2175: 'DIMENSION_21_7_5',
    Dimension25575: 'DIMENSION_25_5_7_5',
    Dimension492145: 'DIMENSION_49_2_14_5',
    Dimension2030: 'DIMENSION_20_30',
    Dimension30120: 'DIMENSION_30_120',
    Dimension20120: 'DIMENSION_20_120'
} as const;
export type AlternativeSizeSizeEnum = typeof AlternativeSizeSizeEnum[keyof typeof AlternativeSizeSizeEnum];


/**
 * Check if a given object implements the AlternativeSize interface.
 */
export function instanceOfAlternativeSize(value: object): value is AlternativeSize {
    return true;
}

export function AlternativeSizeFromJSON(json: any): AlternativeSize {
    return AlternativeSizeFromJSONTyped(json, false);
}

export function AlternativeSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlternativeSize {
    if (json == null) {
        return json;
    }
    return {
        
        'size': json['size'] == null ? undefined : json['size'],
        'ean': json['ean'] == null ? undefined : json['ean'],
    };
}

export function AlternativeSizeToJSON(json: any): AlternativeSize {
    return AlternativeSizeToJSONTyped(json, false);
}

export function AlternativeSizeToJSONTyped(value?: AlternativeSize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'size': value['size'],
        'ean': value['ean'],
    };
}

